export default "__VITE_ASSET__15843dd3__"